module.exports = __webpack_public_path__ + "fonts/Calibre-Light.62b8f0fd.woff";